@if (error) {
<app-alert (close)="error = null" type="error" class="mt-3"
  >{{ error }}</app-alert
>
} @if(userCriminalRecordCheck && signedCriminalRecordCheckDocument){
<div class="d-flex justify-content-end mt-2 mb-4">
  Status:
  <div class="ms-2 me-2">
    {{ utils.getStatus(userCriminalRecordCheck.status) }}
  </div>
  <mat-icon class="{{ utils.getStatusColor(userCriminalRecordCheck.status) }}">
    {{ utils.getStatusIcon(userCriminalRecordCheck.status) }}
  </mat-icon>
</div>

<div>
  <mat-tab-group style="height: 100%">
    <mat-tab label="Document" style="height: 100%">
      <div class="mt-3 ms-3">
        <div
          *ngIf="signatureOutOfDate"
          style="width: 100%; background-color: orange; padding: 8px"
        >
          <p style="color: white; text-align: center; margin-top: 8px">
            Criminal record check document out of date!
          </p>
        </div>
        <display-input
          title="Document Title"
          [value]="signedCriminalRecordCheckDocument.title"
        />
        <display-input
          title="Document Version"
          [value]="signedCriminalRecordCheckDocument.version"
        />

        <embed
          [src]="safeDocumentUrl"
          type="application/pdf"
          width="100%"
          height="500"
        />
      </div>
    </mat-tab>
    <mat-tab label="Signature">
      <div class="mt-3 ms-3">
        <display-input title="Signed At" [value]="signature?.signedAt" />
        <display-input title="Signed On" [value]="signedOn" />
        <img [src]="signature?.signatureUrl" />
      </div>
    </mat-tab>
    <mat-tab label="Processed Document">
      <div class="mt-3 ms-3">
        @if(!uploadPreview){
        <div class="file-upload mt-4">
          <label for="file">Upload Document (PDF):</label>
          <div
            class="upload-dropzone p-5"
            (click)="fileInput.click()"
            (drop)="onFileDrop($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            [class.active]="dragActive"
          >
            <div style="text-align: center">
              <p>Drag and drop your PDF here, or click to select</p>
              <mat-icon class="drop-icon">article</mat-icon>
            </div>
          </div>
          <input
            #fileInput
            id="file"
            type="file"
            accept="application/pdf"
            (change)="onFileSelected($event)"
            hidden
          />
        </div>
        } @if(uploadPreview){
        <div class="mt-2">
          <div class="close-icon" (click)="closePreview()">
            <mat-icon matListItemIcon>close</mat-icon>
          </div>
          <p>Upload:</p>
          <embed
            [src]="uploadPreview"
            type="application/pdf"
            width="100%"
            height="600"
          />
        </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
}
<div class="d-flex align-items-center justify-content-end mt-3">
  @if (loading) {
  <mat-progress-spinner mode="indeterminate" color="primary" diameter="30" />
  } @else if (selectedFile) {
  <button
    (click)="uploadUserCriminalRecordCheck()"
    mat-raised-button
    class="px-4"
  >
    Save
  </button>
  } @else if(uploadPreview && userCriminalRecordCheck?.fileUrl) {
  <div class="d-flex align-items-center">
    <button
      (click)="onDeclineClicked()"
      [disabled]="!userCriminalRecordCheck?.fileUrl || userCriminalRecordCheck?.status == 'declined'"
      mat-raised-button
      color="warn"
      class="me-3 px-4"
    >
      Decline
    </button>

    <button
      (click)="onApproveClicked()"
      [disabled]="!userCriminalRecordCheck?.fileUrl ||userCriminalRecordCheck?.status == 'approved'"
      mat-raised-button
      class="px-4"
    >
      Approve
    </button>
  </div>
  }
</div>

@if (!signature && !signedCriminalRecordCheckDocument && !loading) {
<ng-template>
  <div class="d-flex justify-content-center align-items-center">
    <div class="text-center">
      <div class="d-flex align-items-center" style="height: 80vh">
        <div>
          <mat-icon class="me-2">article</mat-icon>
          <div>Criminal record check document not signed</div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
}
